import styled from 'styled-components';
import { Tab } from '@material-ui/core';

export const StyledTab = styled(Tab)`
  font-weight: 700;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.secondary.main};
  min-width: auto;
`;
